import React, { useState, useEffect, useRef } from "react";
import { Link, useLocation } from "react-router-dom";
import Axios from "axios";
import { ALERT_API_BASE_URL, API_BASE_URL } from "../../Config";

const HorizontalSidebar = () => {
  const location = useLocation();
  const sidebarRef = useRef(null);

  const [menuData, setMenuData] = useState([]);
  // const [alertData, setAlertData] = useState(null);
  const [activeMenus, setActiveMenus] = useState({});
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      const userDataString = sessionStorage.getItem("userData");
      if (userDataString) {
        const userData = JSON.parse(userDataString);
        if (userData.OrgId && userData.RoleId) {
          try {
            const response = await Axios.get(
              `${API_BASE_URL}Admin/getmenu?OrgId=${userData.OrgId}&RoleId=${userData.RoleId}`
            );
            setMenuData(response.data.ResultData || []);
            // console.log(response.data.ResultData, 'menu items dataaaa for girreesh....');
          } catch (error) {
            console.log(error);
          }
        }
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
      setActiveMenus({});
    }
  };
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const toggleMenu = (menuKey, level) => {
    setActiveMenus((prevActiveMenus) => {
      const updatedMenus = { ...prevActiveMenus };

      if (updatedMenus[level] === menuKey) {
        delete updatedMenus[level];
      } else {
        updatedMenus[level] = menuKey;
      }

      const levelsToClear = Object.keys(updatedMenus).filter(
        (keyLevel) => parseInt(keyLevel) > level
      );
      levelsToClear.forEach((keyLevel) => delete updatedMenus[keyLevel]);

      return updatedMenus;
    });
  };

  const handleSubItemClick = () => {
    setActiveMenus({});
  };

  const isMenuActive = (menuKey, level) => {
    return activeMenus[level] === menuKey;
  };

  const renderIcon = (menu) => {
    switch (menu) {
      case "Dashboard":
        return <i className="fa-solid fa-house"></i>;
      case "Masters":
        return <img src="/assets/img/icons/gear.svg" alt="img" />;
      case "Products":
        return <img src="/assets/img/icons/product.svg" alt="img" />;
      case "Purchases":
        return <img src="/assets/img/icons/purchase1.svg" alt="img" />;
      case "Sales":
        return <img src="/assets/img/icons/product.svg" alt="img" />;
      case "Report":
        return <img src="/assets/img/icons/printer.svg" alt="img" />;
      case "Stock":
        return <img src="/assets/img/icons/sales1.svg" alt="img" />;
      default:
        return null;
    }
  };

  const renderMenuItems = (menuItems, parentKey = "", level = 1) => {
    return menuItems.map((menu, index) => {
      const menuKey = `${parentKey}_${menu.MenuName}_${index}`;
      const hasSubItems = menu.SubItems && menu.SubItems.length > 0;
      const isActive = isMenuActive(menuKey, level);

      // if (hasSubItems && menu.SubItems[0] && menu.SubItems[0].MenuPath) {
      //   console.log(menu.SubItems[0].MenuPath, 'm m m m m m m m m');
      // }

      // Special handling for "Dashboard"
      // if (menu.MenuName === "Dashboard") {
      //   return (
      //     <li className="submenu mt-1" key={menuKey}>
      //       <Link to={`${menu.SubItems[0].MenuPath}`} onClick={handleSubItemClick}>
      //         {renderIcon(menu.MenuName)}
      //       </Link>
      //     </li>
      //   );
      // }

      if (menu.MenuName === "Dashboard") {
        const subItemPath = menu.SubItems && menu.SubItems.length > 0 ? menu.SubItems[0].MenuPath : "#";
      
        return (
          <li className="submenu mt-1" key={menuKey}>
            <Link to={subItemPath} onClick={handleSubItemClick}>
              {renderIcon(menu.MenuName)}
              {/* No text or sub-menu for Dashboard */}
            </Link>
          </li>
        );
      }

      // Render other menus normally
      return (
        <li className="submenu" key={menuKey}>
          <Link
            to={hasSubItems ? "#" : menu.MenuPath}
            onClick={() => {
              if (hasSubItems) {
                toggleMenu(menuKey, level);
              } else {
                handleSubItemClick();
              }
            }}
            className={isActive ? "subdrop" : ""}
          >
            {renderIcon(menu.MenuName)}
            <span>{menu.MenuName}</span>
            {hasSubItems && <span className="menu-arrow" />}
          </Link>

          {/* Handle submenus */}
          {hasSubItems && (
            <ul style={{ display: isActive ? "block" : "none" }}>
              {renderMenuItems(menu.SubItems, menuKey, level + 1)}
            </ul>
          )}
        </li>
      );
    });
  };

  const fetchAlertData = async () => {
    const userDataString = sessionStorage.getItem("userData");
    if (userDataString) {
      const userData = JSON.parse(userDataString);
      if (userData.OrgId) {
        try {
          const response = await Axios.get(
            `${ALERT_API_BASE_URL}pc/checklicense?superid=${userData.OrgId}&terminalid=0&locationid=0`
          );
          setIsVisible(response.data);
          console.log(response.data, "alert message response");
        } catch (error) {
          console.error("Error fetching alert data:", error);
        }
      }
    }
  };

  useEffect(() => {
    fetchAlertData();

    const interval = setInterval(fetchAlertData, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setIsVisible(true);
  };

  return (
    <>
      {isMobile ? (
        <div
          ref={sidebarRef}
          className={`sidebar ${
            location.pathname === "/" ||
            location.pathname.startsWith('/view-data') ||
            location.pathname.startsWith('/view-indent-data') ||
            location.pathname.startsWith('/add-sale') ||
            location.pathname.startsWith('/pos-jewellery')
             ? "d-none" 
             : "d-block"
            }`}          style={{ overflowY: "auto", maxHeight: "100vh", backgroundColor: "black" }}
        >
          <div id="sidebar-menu-3" className="sidebar-menu">
            <ul style={{ padding: 0, margin: 0,color:'red' }}>
              {menuData.length > 0 && renderMenuItems(menuData)}
            </ul>
          </div>
        </div>
      ) : (
        <div
          ref={sidebarRef}
          className={`sidebar horizontal-sidebar ${
              location.pathname === "/" ||
              location.pathname.startsWith('/view-data') ||
              location.pathname.startsWith('/view-indent-data') ||
              location.pathname.startsWith('/add-sale') ||
              location.pathname.startsWith('/pos-jewellery')
               ? "d-none" 
               : "d-block"
              }`}
        >
          <div id="sidebar-menu-3" className="sidebar-menu" style={{ position: "relative" }}>
            <ul className="nav">
                {menuData.length > 0 && renderMenuItems(menuData)}
            </ul>

          </div>
           {!isVisible && (
            <>
            <div
              style={{
                position: 'fixed',
                top: '0',
                left: '0',
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: '10000',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <div className="modal-dialog modal-dialog-centered custom-modal-two">
                <div className="modal-content">
                  <div className="page-wrapper-new p-0">
                    <div className="content">
                      <div>
                        <button
                          type="button"
                          className="close btn d-flex ms-auto"
                          onClick={handleClose}
                          style={{ cursor: 'default' }}
                        >
                          <span className="text-secondary">x</span>
                        </button>
                        <div className="d-flex px-2 pb-2">
                          <i
                            className="feather-info text-danger flex-shrink-0 me-2"
                            style={{
                              animation: 'blink 1s infinite',
                              fontSize: '2.4rem',
                            }}
                          ></i>
                          <p className="fs-6">
                            To avoid any interruptions in your service, please report to the <br/>
                            administrator to get your subscription renewed at the earliest.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </>
          )} 

        </div>
      )}
    </>
  );
};

export default HorizontalSidebar;


